const BirthdayIcon = ({ size = 24, ...props }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M13.5 5.36485C13.5 5.93113 13.342 6.47421 13.0607 6.87463C12.7794 7.27505 12.3978 7.5 12 7.5C11.6022 7.5 11.2206 7.27505 10.9393 6.87463C10.658 6.47421 10.5 5.93113 10.5 5.36485C10.5 4.1859 11.9997 1.5 11.9997 1.5C11.9997 1.5 13.5 4.1859 13.5 5.36485Z"
                fill="#BBD8ED"
            />
            <path
                d="M12 10V7M12 7C13.1046 7 14 6.10457 14 5C14 3.89543 12.5 1.5 12 1.5C11.5 1.5 10 3.89543 10 5C10 6.10457 10.8954 7 12 7ZM20 15L19.5678 15.6441C18.8349 16.7364 17.2147 16.695 16.5384 15.5667L16.4992 15.5013C15.8203 14.3686 14.179 14.3683 13.4996 15.5007C12.8204 16.6327 11.1794 16.6324 10.5002 15.5003C9.82077 14.3679 8.17943 14.3676 7.5 15.5L7.46005 15.5666C6.78176 16.6971 5.15716 16.7357 4.42585 15.6388L4 15M20 21V14C20 11.7909 18.2091 10 16 10H8C5.79086 10 4 11.7909 4 14V21H20Z"
                stroke="#0069AD"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default BirthdayIcon;